






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Channel } from '../interfaces';
import { subjects } from '../data/subjects';
import ChannelCard from '@/components/ChannelCard.vue';

@Component({
  components: {
    ChannelCard,
  },
})
export default class SubjectChannels extends Vue {
  @State('channels') private stateChannels!: Channel[];
  @Mutation('setSubject') private mutationSetSubject: any;

  private subjects: string[] = subjects;
  private playlists: any[] = require('../data/playlists.json');
  private channelsToDisplay: Channel[] = [];
  private sort = 'name';

  private playlistHover: boolean = false;

  public async mounted() {
    this.mutationSetSubject(this.$route.params.subject.replace(/\+/g, ' '));
    this.channelsToDisplay = this.channelsForSubject();
  }

  @Watch('$route')
  private onRouteChanged(val: string, oldVal: string) {
    this.channelsToDisplay = this.channelsForSubject();
    this.sort = 'name';
  }

  @Watch('stateChannels')
  private updateChannels(val: any, oldVal: any) {
    this.channelsToDisplay = this.channelsForSubject();
  }

  private channelsForSubject() {
    if (this.stateChannels) {
      return this.stateChannels.filter((channel) => {
        return channel.subject.localeCompare(this.routeName) === 0;
      });
    } else {
      return [];
    }
  }

  private setChannelsToDisplay() {
    switch (this.sort) {
      case 'name':
        this.channelsToDisplay = this.channelsToDisplay.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'subscribers':
        this.channelsToDisplay = this.channelsToDisplay.sort((a, b) => b.subscriberCount - a.subscriberCount);
        break;
      case 'videos':
        this.channelsToDisplay = this.channelsToDisplay.sort((a, b) => b.videoCount - a.videoCount);
        break;
      default:
        break;
    }
  }

  get routeName(): string {
    if (this.$route.params.subject) {
      return this.$route.params.subject.replace(/\+/g, ' ');
    } else {
      return '';
    }
  }

  get subjectImageIndex() {
    return this.subjects.indexOf(this.routeName);
  }

  get playlistForSubject() {
    return this.playlists.find((playlist) => {
      return playlist.subject.localeCompare(this.routeName) === 0;
    });
  }

}
